import React from 'react';

import Pic1 from '../../InstallImages/NEP/NEP_1';

const link = <a href="https://www.dropbox.com/s/rswyl7froomx805/NEP-RSD-1_For%20App.pdf?dl=0" rel="noopener noreferrer" target="_blank">NEP RSD Presentation</a>;

const ModuleLevel = () => (
    <div>
        <div className="col span-1-of-2">
            <Pic1 />
        </div>
        <div className="col span-1-of-2">
            <p className="specsText">Northern Electric & Power Inc. (NEP) Module-Level Rapid Shutdown (RSD) and Monitoring adds the peace of mind that, no matter where you are in the world, that your system is safe and working properly. Adding RSD an important factor when engineering the best system for you. Whether it is your home or business, pairing your solar PV array with Sol-Ark inverters, Batteries and NEP.
            </p>
            <p className="specsText">A RSD connects directly to the panel giving module level insight and safety. If needed, the RSD will shut down each panel making it safer for first responders and technicians. Module level monitoring also makes maintenance easy and ensures your system is working as it should. With panel level control and protection, the NEP RSD provides:
                <li className="specsText"> Over temperature protection</li>
                <li className="specsText"> Over voltage protection</li>
                <li className="specsText">Over current protection</li>
            </p>
            <ul> <h1>Key Features</h1>
                <li className="specsText"> NEC 2014/20t17 690.12 (CEC 2015 64-218) rapid shutdown compliant </li>
                <li className="specsText"> Module level shutdown and monitoring (option)</li>
                <li className="specsText">Over temperature protection</li>
                <li className="specsText">{link}</li>
            </ul>
        </div>
    </div>
);


export default ModuleLevel;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/SystemSpecs/ModuleLevel/NEPRS.js